import React from 'react';

const PromotionPage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <div className="flex-grow flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="text-center">
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-gray-800 mb-6">
            Coming Soon
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl text-gray-600 mb-8">
            Our exciting promotion is on the way. Stay tuned!
          </p>
        </div>
      </div>
    </div>
  );
}

export default PromotionPage;
